import { BackgroundJobType } from 'types/graphql'

type PillLabelCopy = {
  pillActionLabel: string
  pillTerminalActionLabel: string
}

/** Mirrors api/src/services/backgroundJobs/pillTrackableJobTypes.ts */
const pillLabelCopyByType: Partial<Record<BackgroundJobType, PillLabelCopy>> = {
  BulkCancelInspections: {
    pillActionLabel: 'Cancelling inspections',
    pillTerminalActionLabel: 'Cancel',
  },
  BulkCloseRecords: {
    pillActionLabel: 'Closing records',
    pillTerminalActionLabel: 'Close',
  },
  BulkReassignInspections: {
    pillActionLabel: 'Reassigning inspections',
    pillTerminalActionLabel: 'Reassign',
  },
  BulkScheduleInspections: {
    pillActionLabel: 'Scheduling inspections',
    pillTerminalActionLabel: 'Schedule',
  },
  BulkReassignRecords: {
    pillActionLabel: 'Reassigning record owner',
    pillTerminalActionLabel: 'Reassign',
  },
  BulkReassignTasks: {
    pillActionLabel: 'Reassigning tasks',
    pillTerminalActionLabel: 'Reassign',
  },
  BulkSetExpirationDate: {
    pillActionLabel: 'Setting expiration',
    pillTerminalActionLabel: 'Set expiration',
  },
}

export const getBackgroundJobPillLabels = (type: BackgroundJobType): PillLabelCopy | null =>
  pillLabelCopyByType[type] ?? null
